import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Import useAuth
import { Button } from '../components/ui/button'; // ShadCN Button
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar'; // ShadCN Avatar
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '../components/ui/dropdown-menu'; // ShadCN Dropdown components
import { Network } from 'lucide-react';

const Header = () => {
    const { currentUser, logout } = useAuth(); // Destructure currentUser and logout from context
    const navigate = useNavigate(); // Initialize useNavigate

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };


    return (
        <>
            {/* Navigation */}
            <header className="border-b border-slate-200 bg-white">
                <div className="container mx-auto flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center">
                            <Network className="h-8 w-8 text-indigo-600" />
                            <span className="ml-2 text-xl font-bold">AI Crawl</span>
                        </Link>
                        <nav className="ml-10 hidden space-x-8 md:flex">
                            <Link
                                to="/scraper"
                                className="text-sm font-medium text-gray-600 hover:text-gray-900"
                            >
                                Scrape
                            </Link>
                        </nav>
                    </div>
                    <div className="flex items-center space-x-4">
                        {currentUser ? (
                            <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                    <Avatar className="cursor-pointer">
                                        <AvatarImage src={currentUser?.photoURL} />
                                        <AvatarFallback className="bg-indigo-100 text-indigo-600">
                                            {currentUser?.name?.charAt(0).toUpperCase() || 'U'}
                                        </AvatarFallback>
                                    </Avatar>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent align="end">
                                    <DropdownMenuItem onClick={() => navigate('/profile')}>
                                        Profile
                                    </DropdownMenuItem>
                                    <DropdownMenuItem onClick={handleLogout}>
                                        Logout
                                    </DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        ) : (
                            <div className="flex items-center space-x-4">
                                <Button
                                    variant="ghost"
                                    onClick={() => navigate('/login')}
                                    className="text-gray-600 hover:text-gray-900"
                                >
                                    Sign In
                                </Button>
                                <Button
                                    variant="outline"
                                    onClick={() => navigate('/sign-up')}
                                    className="border-indigo-600 text-indigo-600 hover:bg-indigo-50"
                                >
                                    Sign Up
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header; 